import type { TFunction } from "i18next";
import { BillingSupportNumber } from "../../components/UpfrontPayment/types";
import { AccordionProps } from "../../components/shared/Accordion/Accordions";
import { CardProps } from "../../components/shared/Cards/Card";
import gc from "../../assets/images/geneticCounselor.png";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import { HelpFAQAnswerWrapper } from "./Help.styles";

export const helpAccordions = (
  t: TFunction<"translation">,
): AccordionProps[] => [
  {
    title: t("help.faq.howToGetTesting"),
    content: (
      <HelpFAQAnswerWrapper>
        {GetTypographyContent({
          content: t("help.faq.howToGetTestingIntro"),
          size: "medium",
        })}
        {GetTypographyContent({
          content: "support@unityscreen.com",
          size: "medium",
          isEmail: true,
        })}
        {GetTypographyContent({
          content: t("help.faq.howToGetTestingOutro"),
          size: "medium",
        })}
      </HelpFAQAnswerWrapper>
    ),
    key: "howToGetTesting",
  },
  {
    title: t("help.faq.unityCompleteCovered"),
    content: (
      <HelpFAQAnswerWrapper>
        {GetTypographyContent({
          content: t("help.faq.unityCompleteCoveredIntro"),
          size: "medium",
        })}
        {GetTypographyContent({
          content: "support@unityscreen.com",
          size: "medium",
          isEmail: true,
        })}
        {GetTypographyContent({
          content: t("help.faq.unityCompleteCoveredPhonePrefix"),
          size: "medium",
        })}
        {GetTypographyContent({
          content: BillingSupportNumber,
          size: "medium",
          isPhone: true,
        })}
        {GetTypographyContent({
          content: t("help.faq.unityCompleteCoveredOutro"),
          size: "medium",
        })}
      </HelpFAQAnswerWrapper>
    ),
    key: "isCovered",
  },
  {
    title: t("help.faq.moreQuestions"),
    content: (
      <HelpFAQAnswerWrapper>
        {GetTypographyContent({
          content: t("help.faq.moreQuestionsIntro"),
          size: "medium",
        })}
        {GetTypographyContent({
          content: t("help.faq.schedulingPage"),
          size: "medium",
          link: "./scheduling",
          textColor: "greenMedium",
        })}
      </HelpFAQAnswerWrapper>
    ),

    key: "moreQuestions",
  },
];

export const helpLargeCard: CardProps = {
  buttons: [],
  component: "img",
  titleTypography: {
    content: "Schedule a complimentary genetic counseling session",
    isBold: true,
    isCaps: false,
    size: "h2",
    padding: "15px 0px 18px 0",
  },
  bodyTypography: {
    content:
      "Our board certified and licensed genetic counselors are available to answer your questions and help you understand your results",
    isBold: false,
    isCaps: false,
    size: "large",
    padding: "0px 0px 45px 0",
  },
  gridDimension: "4fr 6fr",
  src: gc,
  buttonSize: "medium",
};
